import React, { memo } from 'react'
import { Autocomplete } from 'components/forms/autocomplete/DPLAutocomplete'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'
import { Checkbox } from 'components/forms'

interface IShipperProps {
  shipperId?: number
  shipperName?: string
  isShipperExclusive: boolean | null
  onChange: (arg: Partial<ChangeRateData>) => void
  disabled: boolean
}

export const Shipper = memo<IShipperProps>(
  ({ disabled, isShipperExclusive, onChange, shipperId, shipperName }) => {
    const onChangeShipper = ({
      value,
      fullSelection: { name } = {},
    }: {
      value: string
      fullSelection: { name?: string }
    }) => {
      onChange({
        shipperId: value || undefined,
        shipperName: name || undefined,
        isShipperExclusive: false,
      })
    }
    const onChecked = ({ target: { checked, id } }: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ [id]: checked })
    }
    return (
      <>
        <h3>Shipper</h3>
        <div className='row'>
          <div className='col-md-4'>
            <div data-test='add-shipper'>
              <Autocomplete
                value={shipperName}
                onChange={onChangeShipper}
                placeholder='Search by Name'
                id='shipper'
                type='shipper_confirmed'
                label='Preferred shipper (optional)'
                disabled={disabled}
              />
            </div>
          </div>
        </div>
        {shipperId && (
          <div className='row'>
            <div className='col-xs-12'>
              <Checkbox
                id='isShipperExclusive'
                dataTest='is-shipper-exclusive'
                label='Only offer shipments belonging to this shipper.'
                checked={Boolean(isShipperExclusive)}
                onChange={onChecked}
              />
            </div>
          </div>
        )}
      </>
    )
  }
)
